/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_EraseInputs */

const en_landing_studio_erase = /** @type {(inputs: Landing_Studio_EraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erase`)
};

const zh_landing_studio_erase = /** @type {(inputs: Landing_Studio_EraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`橡皮`)
};

/**
* | output |
* | --- |
* | "Erase" |
*
* @param {Landing_Studio_EraseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_erase = /** @type {((inputs?: Landing_Studio_EraseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_EraseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_erase(inputs)
	return zh_landing_studio_erase(inputs)
});
export { landing_studio_erase as "landing.studio.erase" }